export default "__VITE_ASSET__Cb0Uth9A__"